<template>
	<div :class="{'setting-group':true,'graph-text-settings':true,'toggled':toggled,toggleable:true}" @click="toggleIt ( $event, true )">

		<h4 class="settings-group-title" v-if="title"><span v-html="title" /> <span class="toggle-link" @click="toggleIt ( $event, false )" v-html="toggled?'&lt;&lt; Hide &gt;&gt;':'&lt;&lt; Click here to view/edit &gt;&gt;'" /></h4>

		<div v-if="toggled">

			<div class="font-sizes-grid">

				<ColourPicker 
					v-model="localSettings.legendColor"
					position="top-center" 
					title="Legend Font Size/Color"
					:default='defaultColours.legendColor' 
					class="color-picker" 
					:formInput="{
						type: 'number',
						name: 'legendFontSize',
						placeholder: formInputDefault.legendFontSize,
						min: 8,
						max: 60,
						required: false,
						value: localSettings.legendFontSize
					}"
					@form-input-change="updateLocalSetting('legendFontSize',$event)"
				/>

				<ColourPicker 
					v-model="localSettings.axisColor"
					position="top-center" 
					title="Axis Labels Font Size/Color"
					:default='defaultColours.axisColor' 
					class="color-picker" 
					:formInput="{
						type: 'number',
						name: 'axisFontSize',
						placeholder: formInputDefault.axisFontSize,
						min: 8,
						max: 60,
						required: false,
						value: localSettings.axisFontSize
					}"
					@form-input-change="updateLocalSetting('axisFontSize',$event)"
				/>
				
			</div>
		</div>
	</div>
</template>

<script>
	import Vue from "vue";
	import FormInput from "../Form/Input.vue";
	import ColourPicker from "../Display/ColourPicker.vue";			

	export default {
		name: "GraphTextSettings",
		components: {
			FormInput,
			ColourPicker
		},
		props: {
			defaultSettings: {
				type: Object,
				default: () => ({}),
			},
			settings: {
				type: Object,
				default: () => ({}),
			},
			isOverride: {
				type: Boolean,
				default: false,
			},
		},
		data() {
			return {
				toggled: false,
				showTitleColorPicker: false,
				showLegendColorPicker: false,
				showAxisColorPicker: false,
				localSettings: {
					graphTitle: '',
					titleColor: null,
					legendColor: null,
					axisColor: null,
					titleFontSize: null,
					legendFontSize: null,
					axisFontSize: null,
				},
				defaultColours: {
					titleColor: '#000000',
					legendColor: '#000000',
					axisColor: '#000000'
				}
			};
		},
		methods: {
			updateLocalSetting( key, value ) {
				Vue.set(this.localSettings, key, value);
			},
			toggleIt ( e, isParent ) {

				if ( isParent && this.toggled ) return;

				e.stopPropagation();

				this.toggled = !this.toggled;

			}
		},
		watch: {
			localSettings: {
				handler: function (newVal, oldVal) {
					this.$emit('update', { value: this.localSettings, isOverride: this.isOverride, updated: Object.keys(this.localSettings) });
				},
				deep: true
			}
		},
		computed: {
			title () {
				return this.isOverride ? 'Graph Text Settings' : 'Graph Component Defaults';
			},
			defaults () {

				let defaults = {};

				Object.keys(this.localSettings).forEach(function ( key ) {

					defaults[key] = '';

					if ( !this.defaultColours[key] ) return;

					if ( this.localSettings[key] === this.defaultColours[key] ) {
						defaults[key] = 'Default';
						return;
					}

					if ( this.isOverride ) {

						if ( this.defaultSettings[key] && this.localSettings[key] === this.defaultSettings[key] ) {
							defaults[key] = 'Report Default';
						}

					}

				}.bind(this));

				return defaults;
			},
			formInputDefault () {

				let defaults = {};

				['legendFontSize', 'axisFontSize'].forEach(function ( key ) {

					defaults[key] = 'Default 30';

					if ( this.isOverride && this.defaultSettings[key] ) {

						defaults[key] = 'Report Default (' + this.defaultSettings[key] + ')';

					}


				}.bind(this));

				return defaults;
			}
		},
		created() {
			Object.keys(this.localSettings).forEach(function ( key ) {
				if ( this.settings[key] ) {
					Vue.set(this.localSettings, key, this.settings[key]);
					return;
				}
				if ( this.isOverride && !!this.defaultSettings[key] ) {
					//Vue.set(this.localSettings, key, this.defaultSettings[key]);
					return;
				}
				if ( !this.localSettings[key] && !!this.defaultColours[key] ) {
					Vue.set(this.localSettings, key, this.defaultColours[key]);
				}
			}.bind(this));
		},
	};
</script>

<style lang="less" scoped>
	@import "../../assets/css/less/_settings.less";
	.settings-group-grid {
		display: grid;
		grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
		gap: 1rem;
		margin-bottom: 1rem;
	}

	.graph-text-settings {
		margin-top: 20px;
		
		h4 {
			margin-bottom: 15px;
		}

		.font-sizes-grid {
			display: grid;
			grid-template-columns: repeat(3, 1fr);
			gap: 15px;
			margin-top: 15px;
		}
	}

	.setting-group {
		margin: 0;

		label {
			display: block;
			margin-bottom: 0.5rem;
			font-weight: 500;
		}

		.settings-group-description {
			padding: 0;
			margin: 0 0 1rem;
		}

		.settings-group-title {
			margin-bottom: 0.5rem;
		}

		.large-button {
			&.mini {
				margin: 10px 20px 10px 0;
			}
		}

		.logo-preview {
			max-width: 250px;
			height: auto;
			max-width: 100px;
		}

		hr {
			margin: 0 0 1rem;
		}
	}

	.font-sizes-grid {
		display: grid;
		grid-template-columns: repeat(3, 1fr);
		gap: 15px;
		margin-top: 15px;
	}

	.font-setting {
		position: relative;
		.color-picker {
			position: absolute;
			bottom: 6px;
    		right: 7px;
		}
	}
	.toggled {
		background-color: fade(@formDefaultColour, 5%);
		padding: 1rem;
		border-radius: 0.5rem;
		margin-top: 1rem;
	}
	.toggle-link {
		cursor: pointer;
		opacity: 0.9;
		font-weight: normal;
		display: inline-block;
		margin-left: 0.4rem;
		&:hover {
			opacity: 1;
		}
	}
// Enhanced styles for better discoverability of toggle sections
// Add these styles to your existing LESS files or create a new one to import

// Common styles for all three components
.settings-group, .table-settings-section, .setting-group {
  
  // Enhanced styling when collapsed (not toggled)
  &:not(.toggled) {
    background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
    border: 2px solid #dee2e6;
    border-radius: 12px;
    padding: 1rem 1.5rem;
    margin: 0.5rem 0 0;
    transition: all 0.3s ease;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    
    // Subtle animated gradient background
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: -100%;
      width: 100%;
      height: 100%;
      background: linear-gradient(90deg, transparent, rgba(255,255,255,0.4), transparent);
      transition: left 0.6s ease;
    }

	&.toggleable {
    
		&:hover {
		transform: translateY(-2px);
		box-shadow: 0 8px 25px rgba(0,0,0,0.1);
		border-color: #6c757d;
		
		&::before {
			left: 100%;
		}
		
		.toggle-link {
			color: #495057;
			font-weight: 600;
		}
		
		h4 {
			color: #495057;
		}
		}

	}
    
    // Add subtle pulse animation to draw attention
    animation: subtle-pulse 3s ease-in-out infinite;
  }
  
  // Enhanced h4 styling
  h4 {
    margin-bottom: 0.5rem;
    color: #6c757d;
    font-weight: 600;
    font-size: 1.1rem;
    transition: color 0.3s ease;
    
    // Add an icon before the title
    &::before {
      content: '⚙️';
      margin-right: 0.5rem;
      font-size: 1rem;
    }
  }
  
  // Specific icons for each component type
  &.settings-group h4::before {
    content: '📐'; // Page margins icon
  }
  
  &.table-settings-section h4::before {
    content: '📊'; // Table icon
  }
  
  &.graph-text-settings h4::before {
    content: '📈'; // Graph icon
  }
}

// Enhanced toggle link styling
.toggle-link {
  cursor: pointer;
  opacity: 0.8;
  font-weight: 500;
  display: inline-block;
  margin-left: 0.5rem;
  color: #6c757d;
  transition: all 0.3s ease;
  padding: 0.25rem 0.75rem;
  background: rgba(108, 117, 125, 0.1);
  border-radius: 20px;
  font-size: 0.85rem;
  border: 1px solid rgba(108, 117, 125, 0.2);
  
  &:hover {
    opacity: 1;
    background: rgba(108, 117, 125, 0.15);
    border-color: rgba(108, 117, 125, 0.3);
    transform: scale(1.05);
  }
  
  // Add arrow indicators
  &::after {
    content: ' →';
    transition: transform 0.3s ease;
  }
  
  // When section is toggled (expanded)
  .toggled & {
    background: rgba(220, 53, 69, 0.1);
    border-color: rgba(220, 53, 69, 0.3);
    color: #dc3545;
    
    &::after {
      content: ' ↑';
      transform: rotate(180deg);
    }
    
    &:hover {
      background: rgba(220, 53, 69, 0.15);
    }
  }
}

// Enhanced toggled (expanded) state
.toggled {
  background-color: fade(@formDefaultColour, 8%);
  padding: 1.5rem;
  border-radius: 12px;
  margin-top: 1rem;
  border: 2px solid fade(@formDefaultColour, 20%);
  box-shadow: 0 4px 15px rgba(0,0,0,0.05);
  
  h4 {
    margin-bottom: 1.5rem;
    color: @formDefaultColour;
    padding-bottom: 0.5rem;
    border-bottom: 2px solid fade(@formDefaultColour, 20%);
  }
}

// Pulse animation for attention
@keyframes subtle-pulse {
  0%, 100% {
    box-shadow: 0 2px 8px rgba(0,0,0,0.05);
  }
  50% {
    box-shadow: 0 4px 15px rgba(0,0,0,0.1);
  }
}

// Responsive adjustments
@media (max-width: 768px) {
  .settings-group, .table-settings-section, .setting-group {
    &:not(.toggled) {
      padding: 1rem;
      margin: 1rem 0;
    }
    
    h4 {
      font-size: 1rem;
    }
    
    .toggle-link {
      display: block;
      margin: 0.5rem 0 0 0;
      text-align: center;
    }
  }
}

// Additional fix for modal scroll containers
.modal-inner-scroll {
  .settings-group, .table-settings-section, .setting-group {
    &:not(.toggled) {
      // Ensure proper sizing within flex containers
      flex: none;
      width: 100%;
      box-sizing: border-box;
    }
  }
}

// Section-specific enhancements
.settings-group:not(.toggled) {
  // Page margins - blue theme
  border-left: 4px solid #007bff;
  
  &:hover {
    border-left-color: #0056b3;
  }
}

.table-settings-section:not(.toggled) {
  // Table settings - green theme  
  border-left: 4px solid #28a745;
  
  &:hover {
    border-left-color: #1e7e34;
  }
}

.graph-text-settings:not(.toggled) {
  // Graph settings - purple theme
  border-left: 4px solid #6f42c1;
  
  &:hover {
    border-left-color: #5a32a3;
  }
}

// Add subtle descriptions when collapsed
.settings-group:not(.toggled) h4::after {
  content: ' - Configure page layout and component positioning';
  font-size: 0.8rem;
  font-weight: normal;
  color: #6c757d;
  display: block;
  margin-top: 0.25rem;
}

.table-settings-section:not(.toggled) h4::after {
  content: ' - Customize table styling, borders, and colors';
  font-size: 0.8rem;
  font-weight: normal;
  color: #6c757d;
  display: block;
  margin-top: 0.25rem;
}

.graph-text-settings:not(.toggled) h4::after {
  content: ' - Set font sizes and colors for chart elements';
  font-size: 0.8rem;
  font-weight: normal;
  color: #6c757d;
  display: block;
  margin-top: 0.25rem;
}
</style>
